import { Component, OnInit, OnChanges, SimpleChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { CampaignEmployeeService } from 'src/app/services/campaign-employee/campaign-employee.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
	selector: 'app-views-employee',
	templateUrl: './views-employee.component.html',
	styleUrls: ['./views-employee.component.scss'],
})
export class ViewsEmployeeComponent implements OnInit, OnChanges {
	@Input() selectedView: any;



	SearchFilters = [];
	employeeUsersActive = [];
	//table
	employeeUsers = [];
	columnMode = ColumnMode;
	SelectionType = SelectionType;
	selected = [];
	disableCheckbox = false;
	assignAll = false;
	isLoading = false;

	constructor(private campaignEmployeeService: CampaignEmployeeService,
				private usersSrv: UserService) {}

	//field search
	@ViewChild('Login') login: ElementRef;
	@ViewChild('First') first: ElementRef;
	@ViewChild('last') last: ElementRef;

	ngOnInit(): void {
		this.getListUsers();
	}

	ngOnChanges(changes: SimpleChanges): void {
		// Check if selectedView property has changed
		if (changes['selectedView'] && !changes['selectedView'].firstChange) {
			this.onSelectedViewChange(changes['selectedView'].currentValue);
		}
	}

	/**
	 * Function that executes when selectedView variable changes
	 */
	onSelectedViewChange(newSelectedView: string): void {
		// Reload the users list with the new selected view
		this.getListUsers();

		// Reset selections and filters
		this.selected = [];
		this.employeeUsersActive = [];

		// Clear search filters if they exist
		if (this.login?.nativeElement) {
			this.login.nativeElement.value = '';
		}
		if (this.first?.nativeElement) {
			this.first.nativeElement.value = '';
		}
		if (this.last?.nativeElement) {
			this.last.nativeElement.value = '';
		}
	}

	getListUsers() {
		if (this.selectedView.id != null || this.selectedView.id != '') {
			this.isLoading = true;
			this.usersSrv.getViewPermissions(this.selectedView.id).subscribe({
				next: (data: any) => {
					this.employeeUsers = data.body || [];
					this.assignAll = this.areAllAssigned();
					this.isLoading = false;
					this.disableCheckbox = false;
				},
				error: (error: any) => {
					console.error('Error loading users:', error);
					this.isLoading = false;
					this.disableCheckbox = false;
				}
			});
		}
	}

	assignUsersActive() {
		for (let users of this.employeeUsers) {

			if (users.isActive == '1') {
				this.employeeUsersActive.push(users);
			}
		}

		this.selected = this.employeeUsersActive;
	}

	assignCampaignConfirm(data) {
		// Swal.fire({
		// 	title: 'Assign ' + data.First + ' ' + data.Last + '?',
		// 	text: 'ARE YOU SURE?',
		// 	showCancelButton: true,
		// 	confirmButtonText: 'Yes',
		// 	cancelButtonText: 'Cancel',
		// }).then((result) => {
		// 	if (result.value) {
		// 		this.campaignEmployeeService
		// 			.assignCampaignToUser(data.userid, this.campaignID)
		// 			.subscribe((data: any) => {
		// 				if (data.body == 'Done') {
		// 					Swal.fire("Correctly Assigned");
		// 				} else if (data.error) {
		// 					Swal.fire("Error, Assigning employee");
		// 				}
		// 			});
		// 	} else {
		// 		this.getListUsers();
		// 	}
		// });
	}

	// removeCampaignConfirm(data) {
	// 	Swal.fire({
	// 		title: 'Remove ' + data.First + ' ' + data.Last + '?',
	// 		text: 'ARE YOU SURE?',
	// 		showCancelButton: true,
	// 		confirmButtonText: 'Yes',
	// 		cancelButtonText: 'Cancel',
	// 	}).then((result) => {
	// 		if (result.value) {
	// 			this.campaignEmployeeService
	// 				.removeUser(data.userid, this.campaignID)
	// 				.then((data) => {
	// 					if (data.success) {
	// 						Swal.fire(data.message);
	// 					} else if (data.error) {
	// 						Swal.fire(data.message);
	// 					}
	// 				});
	// 		} else {
	// 			this.employeeUsers = [];
	// 			this.selected = [];
	// 			this.employeeUsersActive = [];
	// 			this.getListUsers();
	// 		}
	// 	});
	// }

	unAssignUser(user){
		// this.disableCheckbox = true;
		// this.campaignEmployeeService
		// 			.removeUser(user, this.campaignID)
		// 			.subscribe((data: any) => {
		// 				if (data.body == 'Done') {

		// 					this.getListUsers();
		// 				} else if (data.error) {
		// 					Swal.fire("Error, Unassigning employee");
		// 					this.disableCheckbox = false;
		// 				}
		// 			});
	}

	assignUser(user_id, isActive: boolean){
		this.disableCheckbox = true;
		const payload = {
			user_id: user_id,
			view_id: this.selectedView.id,
			isActive: isActive ? 1 : 0
		}
		this.usersSrv.assignViewToUser(payload).subscribe({
			next: (data: any) => {
				this.getListUsers();
			},
			error: (error: any) => {
				console.error('Error assigning user to view:', error);
				Swal.fire({
					title: 'Error',
					text: 'Failed to update user assignment',
					icon: 'error'
				});

				// Revert the checkbox state by refreshing the list
				this.getListUsers();
			}
		});
	}

	checkBoxClick(row, event){
		this.isLoading = true;
		if(event.target.checked){
			this.assignUser(row.id, true);
		} else {
			this.assignUser(row.id, false);
		}
	}

	cleanFiltersSearch() {
		this.login.nativeElement.value = '';
		this.first.nativeElement.value = '';
		this.last.nativeElement.value = '';

		this.getListUsers();
	}

	updateFilter(event, opcion) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.employeeUsers;
		} else {
			searchWithFilters = this.SearchFilters;
		}

		switch (opcion) {
			case 1: //login
				answer_filter = searchWithFilters.filter(function (d) {
					return d.Login.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: //first
				answer_filter = searchWithFilters.filter(function (d) {
					return d.First.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 3: //last
				answer_filter = searchWithFilters.filter(function (d) {
					return d.Last.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			default:
				break;
		}

		this.employeeUsers = answer_filter;
	}

	// onActivate(event) {
	// 	if (event.type === 'click') {
	// 		if (event.row.IsActive === '1') {
	// 			this.removeCampaignConfirm(event.row);
	// 		} else {
	// 			this.assignCampaignConfirm(event.row);
	// 		}
	// 	}
	// }




	assignAllCallers(){
		this.assignAll = !this.assignAll;
		this.disableCheckbox = true;
		this.isLoading = true;



		const activeUsers = this.employeeUsers.filter(user => user.isActive == '1').map(user => user.id).join(',');
		const inactiveUsers = this.employeeUsers.filter(user => user.isActive == '0').map(user => user.id).join(',');

		this.employeeUsers = this.employeeUsers.map(user => {
			return {
				...user,
				isActive: this.assignAll ? '1' : '0'
			};
		});

		const payload = {
				users_ids: this.assignAll ? inactiveUsers : activeUsers,
				view_id: this.selectedView.id,
				isActive: this.assignAll ? 1 : 0
			}

		this.usersSrv.assignAllUsersToView(payload).subscribe((data: any)=>{
				this.getListUsers();
			});
	}

	areAllAssigned(){
		return this.employeeUsers.length > 0 && this.employeeUsers.every(user => user.isActive == '1');
	}

	get assignedCount(): number {
		return this.employeeUsers.filter(user => user.isActive == '1').length;
	}
}
